<template>
  <div class="container">
    <v-dialog
      v-model="show"
      max-width="400px"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card class="recover-card pa-6 rounded-xl" dark>
          <div class="text-center mb-4">
            <v-icon large color="#1976d2">mdi-lock-reset</v-icon>
            <h3 class="mt-2 font-weight-bold">Recuperar contraseña</h3>
            <div class="subtitle-2 mt-1">
              Te enviaremos una nueva contraseña por email
            </div>
          </div>

          <v-card-text>
            <v-alert color="purple" dark dismissible outlined
              >El email debe coincidir con el que indicó al dar de alta el
              usuario. Se le enviará un correo con una nueva contraseña
              aleatoria.</v-alert
            >
            <v-row dense>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="paciente.dni"
                  prepend-icon="mdi-account"
                  label="D.N.I"
                  dense
                  required
                  @keypress="onlyNumber"
                  :rules="requiredRules"
                  maxlength="9"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="paciente.mail"
                  prepend-icon="mdi-email"
                  label="E-mail"
                  :rules="emailRules"
                  dense
                  maxlength="80"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click.stop="show = false">Volver</v-btn>
            <v-btn color="success" :disabled="!valid" @click.stop="send"
              >Enviar Email</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    horaTurno: null,
    paciente: {
      dni: null,
      mail: null,
    },

    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    emailRules: [
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
      (v) => !!v || "Dato obligatorio",
    ],
    passwordRules: [
      (v) => (v && v.length > 5) || "Mínimo 6 caracteres",
      (v) => !!v || "Dato obligatorio",
    ],
  }),
  props: ["visible"],

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    send() {
      this.$swal({
        title: "Enviar email de recupero de contraseña",
        text: "¿Desea enviar un correo para restaurar su contraseña?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosUsuario = {
            nrodocumento: this.paciente.dni,
            email: this.paciente.mail,
          };

          let self = this;
          axios
            .post("/Institucional/RecuperarPass", datosUsuario)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title:
                    "No existe ningún usuario registrado con esos datos. Revise el D.N.I y el email ingresados por favor.",
                  vm: self,
                  timer: 4200,
                });
              } else {
                if (response.data == "inactiva") {
                  self.showAlert({
                    icon: "warning",
                    title: "La cuenta aún no ha sido activada.",
                    vm: self,
                    timer: 4200,
                  });
                } else {
                  self.showAlert({
                    icon: "success",
                    title:
                      "Se envió un mail a la casilla de correo registrada con su nueva contraseña. Revise por favor su correo no deseado o spam.",
                    vm: self,
                    timer: 4200,
                  });
                  this.show = false;
                }
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title:
                  "El correo no pudo ser enviado. Intente mas tarde por favor.",
                vm: this,
                timer: 4200,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    vaciarModels() {
      this.paciente.mail = "";
      this.paciente.dni = "";
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },

  created() {
    this.vaciarModels();
  },
};
</script>
<style scoped>
.recover-card {
  backdrop-filter: blur(10px);
  background: rgba(20, 35, 45, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
}
</style>
